"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
exports.Divider = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  width: 100%;\n  height: 0px;\n  border-bottom: 1px solid #dde5fe;\n"], ["\n  position: ", ";\n  width: 100%;\n  height: 0px;\n  border-bottom: 1px solid #dde5fe;\n"])), function (p) { return p.position || "initial"; });
var templateObject_1;
